<template>
  <div class="nav">
    <div class="box">
      <a href="/">
        <img class="logo" src="../../assets/logo.png" alt="" />
      </a>

      <div class="rightbox">

        <div class="boxitem" v-for="item in navdata" :key="item.id">
          <div v-if="item.child">
           
            <el-menu class="menuC" mode="horizontal">
              <el-submenu :index="item.father.id">
                <template slot="title">
                  {{ item.father.navbar_name }}
                </template>
                <div v-for="child in item.child" :key="'c_'+child.id">
                 
                  <el-submenu v-if="child.child_sub[0]" :index="child.id">
                    <template slot="title">
                      <div @click="()=>handleSelect(child,'Zoon')" >
                        {{ child.navbar_name }}
                      </div>
                    </template>

                    <div v-for="child_sub in child.child_sub"  :key="'c_'+child_sub.id">
                      <el-menu-item :index="child_sub.cate_id" @click="()=>handleSelect(child_sub,'Class')">{{child_sub.course_name}}</el-menu-item>
                    </div>
                    
                  </el-submenu>

                   <el-menu-item v-else  @click="()=>handleSelect(child,'Zoon')">
                    {{ child.navbar_name }}
                  </el-menu-item>

                </div>
                
              </el-submenu>
            </el-menu>

          </div>
          <div v-else>
            <el-link
              :underline="false"
              :href="item.father.navbar_url"
              target="_blank"
              >{{ item.father.navbar_name }}</el-link
            >
          </div>
        </div>

        
        <el-select
          class="boxitem"
          v-model="value"
          placeholder="请输入关键词"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          @change="val=>onSelChange(val)">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.course_name"
            :value="item.id">
          </el-option>
        </el-select>

        <el-link
          class="boxlogin"
          :underline="false"
          @click="onlogin"
          v-if="!logindata"
          ><i class="el-icon-user"></i>登录</el-link
        >
        <div class="boxlogin" v-else>
          <i class="el-icon-user"></i>

          <el-dropdown @command="pwdhandleCommand">
            <span class="el-dropdown-link">
              <span @click="onGoUser">个人中心</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/Utils";

export default {
  data: function () {
    return {
      navdata: null,
      logindata: null,
      options: [],
      value: [],
      loading: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.navdata = await this.$fly.get("/common/navbar");
      console.log("navdata:",this.navdata);

      this.logindata = await this.$fly.get("/user/userLoginInfo");
      // console.log("logindata:",this.logindata);
      if (this.logindata.code) {
        this.logindata = null;
      }
    },

    remoteMethod(query) {
      console.log(query);
      if (query !== '') {
        this.loading = true;

        this.$fly.get("course/courseList?keyword="+query).then(result =>{
          // console.log("*********",result);
          this.options = result.course_list.data;
          this.loading = false;
        })

      } else {
        this.options = [];
      }
    },
    onSelChange(id){
      // console.log(id);
      this.$router.push({ name: "Class", params: { id: id } });
    },

    handleSelect(child,val) {
      // console.log(child, val);
      if (child.navbar_url){
        const params = Utils.getUrlAllParams(child.navbar_url);
        // console.log(params,this.$router);
        this.$router.push({ name: val, params: { id: params.id } });
      }
    },

    onlogin() {
      this.$router.push("Login");
    },
    onGoUser() {
      this.$router.push("User");
    },
    pwdhandleCommand(command) {
      if (command == 1) {
        this.$router.push({
          name: "ChangePwd",
          params: { username: this.logindata.user.username },
        });
      }
    },
  },
};
</script>

<style lang='scss'>
.nav {
  background-color: #fff;
  padding: 22px 0;
  font-size: 16px;
  color: #333;

  .box {
    width: 1024px;
    position: relative;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .rightbox {
      position: relative;
      display: flex;
      align-items: center;
    }

    .logo {
      width: 120px;
    }

    .boxitem:first-child {
      margin-left: 0;
    }
    .boxitem {
      margin-left: 30px;
    }

    .boxlogin {
      // position: absolute;
      // right: 0;
      margin-left: 60px;
    }

    .el-icon-user {
      margin-right: 10px;
    }
    .el-link {
      font-size: 16px;
    }
    .el-link:hover {
      color: #00b3a4;
    }

    .el-dropdown {
      font-size: 16px;
    }

    .el-dropdown:hover {
      color: #00b3a4;
    }

    .el-dropdown-link {
      cursor: pointer;
    }

    .menuC{
      border: none;

      .el-submenu__title{
        font-size: 16px;
        height: 21px;
        line-height: normal;
        border: none;
        padding:0;
        color: #606266;

        i{display: none;}
      }

      .is-active{
        .el-submenu__title{
          border: none;
        }
      }

      .el-submenu__title:hover {
        color: #00b3a4;
      }
    }

    


  }
}

.item {
  text-align: center;
}

.el-menu--horizontal{
  ul{
    min-width:0;

    li{
      text-align: center!important;
      padding: 0 20px!important;
      color: #606266!important;
      min-width:0!important;

      .el-submenu__title{
        text-align: center!important;
        padding: 0 20px!important;
        color: #606266!important;
        min-width:0!important;

        i{
          right: 0;
        }
      }

      .el-submenu__title:hover{
         color: #00b3a4!important;
      }
    }

    li:hover {
      color: #00b3a4!important;
    }
  }
}


</style>
